/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x3abea5 from'./../../message.js';class IsEditorBundleUploadedMessage extends _0x3abea5{constructor(_0x2561a8){super(),this['bundleVersion']=_0x2561a8;}['toJSON'](){return{'bundleVersion':this['bundleVersion']};}static['fromJSON'](_0x435906){return new IsEditorBundleUploadedMessage(_0x435906['bundleVersion']);}}IsEditorBundleUploadedMessage['TYPE']='131',IsEditorBundleUploadedMessage['READABLE_TYPE_NAME']='isEditorBundleUploaded',IsEditorBundleUploadedMessage['DESCRIPTOR_NAME']='IsEditorBundleUploadedMessage',IsEditorBundleUploadedMessage['DESCRIPTOR']={'fields':{'bundleVersion':{'type':'string','id':0x1}}};export default IsEditorBundleUploadedMessage;